import { render, staticRenderFns } from "./shopPage.vue?vue&type=template&id=0b8dd7e2&scoped=true"
import script from "./shopPage.vue?vue&type=script&lang=ts"
export * from "./shopPage.vue?vue&type=script&lang=ts"
import style0 from "./shopPage.vue?vue&type=style&index=0&id=0b8dd7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8dd7e2",
  null
  
)

export default component.exports